<template>
    <v-menu
        v-model="menu"
        :close-on-content-click="false"
        :disabled="readonly"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="displayValue"
                :label="label"
                :rules="rules"
                :clearable="!readonly && clearable"
                :hide-details="hideDetails"
                :dense="dense"
                :outlined="outlined"
                prepend-inner-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                @click:clear="$emit('input', null)"
            />
        </template>
        <v-date-picker
            :value="value"
            :first-day-of-week="1"
            no-title
            @input="onPick"
        />
    </v-menu>
</template>

<script>
    import { formatDate } from '@/utils/format'

    // Holds the value as YYYY-MM-DD (what the backend expects) and shows it as DD/MM/YYYY
    export default {
        name: 'DateField',
        props: {
            value: {
                type: String,
                default: null
            },
            label: {
                type: String,
                default: ''
            },
            rules: {
                type: Array,
                default: () => []
            },
            readonly: {
                type: Boolean,
                default: false
            },
            clearable: {
                type: Boolean,
                default: true
            },
            hideDetails: {
                type: [Boolean, String],
                default: false
            },
            dense: {
                type: Boolean,
                default: false
            },
            outlined: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                menu: false
            }
        },
        computed: {
            displayValue() {
                return formatDate(this.value)
            }
        },
        methods: {
            onPick(date) {
                this.menu = false
                this.$emit('input', date)
            }
        }
    }
</script>
